(() => {
  const all = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const rootUrl = () => (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');

  const formatMoney = (cents, format) => {
    const value = Number(cents || 0) / 100;
    const fmt = format || '${{amount}}';
    const grouped = (num, decimals, thousands, decimal) => {
      const parts = num.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (match, key) => {
      if (key === 'amount_no_decimals') return grouped(value, 0, ',', '.');
      if (key === 'amount_with_comma_separator') return grouped(value, 2, '.', ',');
      if (key === 'amount_no_decimals_with_comma_separator') return grouped(value, 0, '.', ',');
      return grouped(value, 2, ',', '.');
    });
  };

  const updateCartCount = (count) => {
    all('[data-bbd-cart-count]').forEach((badge) => {
      badge.textContent = count;
    });
  };

  const setSlide = (gallery, index) => {
    const slides = all('[data-bbd-slide]', gallery);
    const thumbs = all('[data-bbd-thumb]', gallery);
    if (!slides.length) return;
    let next = (index + slides.length) % slides.length;
    if (slides[next].hidden) { const firstVisible = slides.findIndex((s) => !s.hidden); if (firstVisible >= 0) next = firstVisible; }
    slides.forEach((slide, i) => slide.classList.toggle('is-active', i === next));
    thumbs.forEach((thumb, i) => thumb.classList.toggle('is-active', i === next));
    const activeThumb = thumbs[next];
    if (activeThumb) activeThumb.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    const zoom = gallery.querySelector('[data-bbd-zoom]');
    const img = slides[next].querySelector('img');
    if (zoom && img) zoom.href = img.currentSrc || img.src;
    gallery.dataset.index = String(next);
  };

  const filterByColor = (gallery, color) => {
    const slides = all('[data-bbd-slide]', gallery);
    const thumbs = all('[data-bbd-thumb]', gallery);
    if (!color || !slides.some((s) => s.dataset.bbdColor)) return;
    const hasMatch = slides.some((s) => s.dataset.bbdColor === color);
    slides.forEach((s, i) => {
      const c = s.dataset.bbdColor;
      const show = !c || !hasMatch || c === color;
      s.hidden = !show;
      if (thumbs[i]) thumbs[i].hidden = !show;
    });
    const active = gallery.querySelector('[data-bbd-slide].is-active');
    if (!active || active.hidden) setSlide(gallery, 0);
  };

  const initProduct = (root) => {
    if (root.dataset.bbdReady) return;
    root.dataset.bbdReady = '1';
    const jsonEl = root.querySelector('[data-bbd-product-json]');
    const invEl = root.querySelector('[data-bbd-inventory]');
    if (!jsonEl) return;
    const product = JSON.parse(jsonEl.textContent);
    const inventory = invEl ? JSON.parse(invEl.textContent) : {};
    const moneyFormat = root.dataset.moneyFormat;
    const threshold = Number(root.dataset.lowStock || 0);
    const stockText = root.dataset.lowStockText || '';
    const gallery = root.querySelector('[data-bbd-gallery]');

    const selected = () => all('[data-bbd-option]', root).map((group) => {
      const checked = group.querySelector('input:checked');
      return checked ? checked.value : null;
    });

    const refresh = () => {
      const values = selected();
      const variant = product.variants.find((v) => v.options.every((opt, i) => values[i] === undefined || values[i] === null || opt === values[i]));
      const colorIdxEarly = (product.options || []).findIndex((o) => /colou?r/i.test(typeof o === 'string' ? o : o.name));
      if (gallery && colorIdxEarly >= 0 && values[colorIdxEarly]) filterByColor(gallery, values[colorIdxEarly]);
      all('[data-bbd-option]', root).forEach((group, i) => {
        const label = group.querySelector('[data-bbd-option-label]');
        if (label) label.textContent = values[i] || '';
        all('label', group).forEach((item) => {
          const input = item.querySelector('input');
          item.classList.toggle('is-active', input && input.checked);
          if (!input) return;
          const probe = values.slice();
          probe[i] = input.value;
          const match = product.variants.find((v) => v.options.every((opt, k) => opt === probe[k]));
          item.classList.toggle('is-disabled', !match || !match.available);
        });
      });
      const idInput = root.querySelector('[data-bbd-variant-id]');
      const buttons = all('[data-bbd-atc]', root);
      if (!variant) {
        buttons.forEach((btn) => {
          btn.disabled = true;
          const text = btn.querySelector('[data-bbd-atc-text]') || btn;
          text.textContent = btn.dataset.unavailable || 'Unavailable';
        });
        return;
      }
      if (idInput) idInput.value = variant.id;
      all('[data-bbd-price-current]', root).forEach((el) => { el.textContent = formatMoney(variant.price, moneyFormat); });
      all('[data-bbd-price-compare]', root).forEach((el) => {
        const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        el.hidden = !onSale;
        if (onSale) el.textContent = formatMoney(variant.compare_at_price, moneyFormat);
      });
      buttons.forEach((btn) => {
        btn.disabled = !variant.available;
        const text = btn.querySelector('[data-bbd-atc-text]') || btn;
        text.textContent = variant.available ? btn.dataset.label : btn.dataset.soldOut;
      });
      const stock = root.querySelector('[data-bbd-stock]');
      if (stock) {
        const info = inventory[String(variant.id)];
        const qty = info ? info.q : null;
        const low = variant.available && qty !== null && qty > 0 && qty <= threshold;
        stock.hidden = !low;
        if (low) stock.textContent = stockText.replace('[count]', qty);
      }
      const colorIdx = (product.options || []).findIndex((o) => /colou?r/i.test(typeof o === 'string' ? o : o.name));
      if (gallery && colorIdx >= 0) filterByColor(gallery, variant.options[colorIdx]);
      if (variant.featured_media && gallery) {
        const slide = gallery.querySelector(`[data-bbd-slide][data-media-id="${variant.featured_media.id}"]`);
        if (slide) setSlide(gallery, Number(slide.dataset.bbdSlide));
      }
      if (root.dataset.updateUrl === 'true' && window.history && window.history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    };

    root.addEventListener('change', (event) => {
      if (event.target.closest('[data-bbd-option]')) refresh();
    });
    refresh();
  };

  const initRecommendations = (root) => {
    if (root.dataset.bbdReady) return;
    root.dataset.bbdReady = '1';
    const url = root.dataset.url;
    if (!url) return;
    fetch(url)
      .then((response) => response.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('[data-bbd-recs]');
        if (fresh && fresh.querySelector('[data-bbd-card]')) {
          root.innerHTML = fresh.innerHTML;
          root.hidden = false;
          const fallback = root.parentElement && root.parentElement.querySelector('[data-bbd-recs-fallback]');
          if (fallback) fallback.remove();
        }
      })
      .catch(() => {});
  };

  const init = () => {
    all('[data-bbd-product]').forEach(initProduct);
    all('[data-bbd-recs][data-url]').forEach(initRecommendations);
  };

  document.addEventListener('click', (event) => {
    const thumb = event.target.closest('[data-bbd-thumb]');
    if (thumb) {
      setSlide(thumb.closest('[data-bbd-gallery]'), Number(thumb.dataset.bbdThumb));
      return;
    }
    const nav = event.target.closest('[data-bbd-gallery-nav]');
    if (nav) {
      const gallery = nav.closest('[data-bbd-gallery]');
      const navSlides = all('[data-bbd-slide]', gallery);
      const step = Number(nav.dataset.bbdGalleryNav);
      let at = Number(gallery.dataset.index || 0);
      for (let k = 0; k < navSlides.length; k++) {
        at = (at + step + navSlides.length) % navSlides.length;
        if (!navSlides[at].hidden) break;
      }
      setSlide(gallery, at);
      return;
    }
    const tab = event.target.closest('[data-bbd-tabx]');
    if (tab) {
      const box = tab.closest('[data-bbd-tabsx]');
      all('[data-bbd-tabx]', box).forEach((t) => t.classList.toggle('is-active', t === tab));
      all('[data-bbd-panel]', box).forEach((p) => p.classList.toggle('is-active', p.dataset.bbdPanel === tab.dataset.bbdTabx));
      return;
    }
    const qtyBtn = event.target.closest('[data-bbd-qty-btn]');
    if (qtyBtn) {
      const wrap = qtyBtn.closest('.bbd-qty');
      const input = wrap && wrap.querySelector('input');
      if (!input) return;
      const min = Number(input.min || 0);
      input.value = Math.max(min, Number(input.value || 0) + Number(qtyBtn.dataset.bbdQtyBtn));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    const filterOpen = event.target.closest('[data-bbd-filter-open]');
    if (filterOpen) {
      const panel = document.getElementById(filterOpen.dataset.bbdFilterOpen);
      if (panel) {
        panel.classList.add('is-open');
        document.documentElement.classList.add('bbd-lock');
      }
      return;
    }
    const filterClose = event.target.closest('[data-bbd-filter-close]');
    if (filterClose) {
      const panel = filterClose.closest('.bbd-filters');
      if (panel) panel.classList.remove('is-open');
      document.documentElement.classList.remove('bbd-lock');
    }
  });

  let cartTimer;
  document.addEventListener('change', (event) => {
    const auto = event.target.closest('[data-bbd-autosubmit]');
    if (auto && auto.form) {
      clearTimeout(cartTimer);
      cartTimer = setTimeout(() => {
        if (auto.form.requestSubmit) auto.form.requestSubmit();
        else auto.form.submit();
      }, auto.type === 'number' ? 450 : 50);
    }
  });

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-bbd-product-form]');
    if (!form || !window.fetch) return;
    if (event.submitter && event.submitter.hasAttribute('data-bbd-buy-now')) return;
    event.preventDefault();
    const section = form.closest('[data-bbd-product]') || document;
    const buttons = all('[data-bbd-atc]', section);
    const error = section.querySelector('[data-bbd-error]');
    if (error) error.hidden = true;
    buttons.forEach((btn) => { btn.disabled = true; });
    fetch(`${rootUrl()}cart/add.js`, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form),
    })
      .then((response) => response.json().then((data) => ({ ok: response.ok, data })))
      .then(({ ok, data }) => {
        if (!ok) throw new Error(data.description || data.message || 'Error');
        return fetch(`${rootUrl()}cart.js`).then((r) => r.json());
      })
      .then((cart) => {
        updateCartCount(cart.item_count);
        all('[data-bbd-cart-count]').forEach((badge) => { badge.hidden = false; });
        buttons.forEach((btn) => {
          const text = btn.querySelector('[data-bbd-atc-text]') || btn;
          text.textContent = btn.dataset.added || 'Added';
        });
        setTimeout(() => {
          buttons.forEach((btn) => {
            const text = btn.querySelector('[data-bbd-atc-text]') || btn;
            text.textContent = btn.dataset.label;
            btn.disabled = false;
          });
          if (section.dataset && section.dataset.afterAdd === 'cart') window.location.href = `${rootUrl()}cart`;
        }, 1400);
      })
      .catch((err) => {
        buttons.forEach((btn) => { btn.disabled = false; });
        if (error) {
          error.textContent = err.message;
          error.hidden = false;
        }
      });
  });

  init();
  document.addEventListener('shopify:section:load', init);
})();

(() => {
  const KEY_JOINED = 'bbd_crew_joined';
  const KEY_CLOSED = 'bbd_crew_closed';
  const store = {
    get(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} },
  };

  const openPopup = (pop) => {
    if (!pop || !pop.hidden) return;
    pop.hidden = false;
    document.documentElement.classList.add('bbd-lock');
    requestAnimationFrame(() => pop.classList.add('is-open'));
    const first = pop.querySelector('input:not([type="hidden"]), .bbd-sf__copy');
    if (first) setTimeout(() => first.focus({ preventScroll: true }), 350);
  };
  const closePopup = (pop, remember) => {
    if (!pop || pop.hidden) return;
    pop.classList.remove('is-open');
    document.documentElement.classList.remove('bbd-lock');
    setTimeout(() => { pop.hidden = true; }, 300);
    if (remember) store.set(KEY_CLOSED, String(Date.now()));
  };

  const initPopup = () => {
    const pop = document.querySelector('[data-bbd-popup]');
    if (!pop || pop.dataset.ready) return;
    pop.dataset.ready = '1';
    if (pop.querySelector('[data-bbd-signup-success], [data-bbd-signup-error]')) { openPopup(pop); return; }
    if (pop.dataset.design === 'true') return;
    if (store.get(KEY_JOINED)) return;
    const closed = Number(store.get(KEY_CLOSED) || 0);
    const days = Number(pop.dataset.days || 14);
    if (closed && Date.now() - closed < days * 86400000) return;
    setTimeout(() => openPopup(pop), Number(pop.dataset.delay || 8) * 1000);
  };

  const normalizePhone = (raw) => {
    const trimmed = (raw || '').trim();
    const digits = trimmed.replace(/\D/g, '');
    if (!digits) return '';
    if (trimmed.charAt(0) === '+') return '+' + digits;
    if (digits.length === 10) return '+1' + digits;
    if (digits.length === 11 && digits.charAt(0) === '1') return '+' + digits;
    return '+' + digits;
  };

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('form[data-bbd-signup]');
    if (!form) return;
    const hint = form.querySelector('[data-bbd-signup-hint]');
    const say = (msg) => { if (hint) { hint.textContent = msg; hint.hidden = false; } };
    const email = form.querySelector('[data-bbd-email]');
    const emailConsent = form.querySelector('[data-bbd-email-consent]');
    const smsConsent = form.querySelector('[data-bbd-sms-consent]');
    const phone = form.querySelector('[data-bbd-phone]');
    const tags = form.querySelector('[data-bbd-tags]');
    if (hint) hint.hidden = true;
    if (!email || !email.value || !email.checkValidity()) {
      event.preventDefault();
      say(email && email.validationMessage ? email.validationMessage : 'Please enter a valid email address.');
      return;
    }
    if (emailConsent && !emailConsent.checked) {
      event.preventDefault();
      say(form.dataset.emailMsg || 'Please check the email box to join the crew.');
      return;
    }
    if (smsConsent && smsConsent.checked) {
      const value = normalizePhone(phone && phone.value);
      if (!value || value.length < 11) {
        event.preventDefault();
        say(form.dataset.phoneMsg || 'Please enter your mobile number to receive texts.');
        if (phone) phone.focus();
        return;
      }
      phone.value = value;
      phone.name = 'contact[phone]';
      if (tags) {
        const today = new Date().toISOString().slice(0, 10);
        tags.value = tags.value.replace(/,sms-.*$/, '') + ',sms-consent,sms-consent-' + today + ',sms-phone-' + value;
      }
    } else if (phone) {
      phone.removeAttribute('name');
    }
    store.set(KEY_JOINED, '1');
  });

  document.addEventListener('click', (event) => {
    const closer = event.target.closest('[data-bbd-popup-close]');
    if (closer) { closePopup(closer.closest('[data-bbd-popup]'), true); return; }
    const copy = event.target.closest('[data-bbd-copy]');
    if (copy) {
      const label = copy.textContent;
      const done = () => { copy.textContent = copy.dataset.copied || 'Copied!'; setTimeout(() => { copy.textContent = label; }, 1800); };
      if (navigator.clipboard) navigator.clipboard.writeText(copy.dataset.bbdCopy).then(done).catch(done); else done();
    }
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closePopup(document.querySelector('[data-bbd-popup].is-open'), true);
  });
  document.addEventListener('shopify:section:select', (event) => {
    const pop = event.target.querySelector('[data-bbd-popup]');
    if (pop) openPopup(pop);
  });
  document.addEventListener('shopify:section:deselect', (event) => {
    const pop = event.target.querySelector('[data-bbd-popup]');
    if (pop) closePopup(pop, false);
  });

  if (document.querySelector('[data-bbd-signup-success]')) store.set(KEY_JOINED, '1');
  initPopup();
  document.addEventListener('shopify:section:load', initPopup);
})();

(() => {
  document.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-bbd-discount-apply]');
    if (!btn) return;
    const input = document.querySelector('[data-bbd-discount]');
    const code = (input && input.value || '').trim();
    if (!code) { if (input) input.focus(); return; }
    btn.disabled = true;
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    window.location.href = root + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(root + 'cart');
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter') return;
    const input = event.target.closest('[data-bbd-discount]');
    if (!input) return;
    event.preventDefault();
    const btn = document.querySelector('[data-bbd-discount-apply]');
    if (btn) btn.click();
  });
})();

(() => {
  const showInvalidCodes = async () => {
    const box = document.querySelector('[data-bbd-discount-invalid]');
    if (!box) return;
    try {
      const cart = await (await fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart.js')).json();
      const bad = (cart.discount_codes || []).filter((c) => c.applicable === false).map((c) => c.code);
      if (!bad.length) { box.hidden = true; return; }
      const template = box.dataset.template || '[code] is not a valid code';
      box.textContent = bad.map((code) => template.replace('[code]', code)).join(' ');
      box.hidden = false;
    } catch (e) { /* keep hidden */ }
  };
  showInvalidCodes();
  document.addEventListener('shopify:section:load', showInvalidCodes);
})();
